import { useTranslation } from 'react-i18next';
import { Typography } from '@mui/material';

export default function EmptyTag() {

    const { t } = useTranslation();

    return (
        <Typography sx={{ font: 'normal normal normal 16px Segoe UI', opacity: '0.2' }}>
            {t("tag.NoTag")}
        </Typography>
    )
}